import { render, staticRenderFns } from "./extra.vue?vue&type=template&id=a2f9c578&scoped=true"
import script from "./extra.vue?vue&type=script&lang=js"
export * from "./extra.vue?vue&type=script&lang=js"
import style0 from "./extra.vue?vue&type=style&index=0&id=a2f9c578&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f9c578",
  null
  
)

export default component.exports